/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from "react-intl";
import { SidebarMenuItem } from "./SidebarMenuItem";
import { SidebarMenuItemWithSub } from "./SidebarMenuItemWithSub";
import { useAuth } from "../../../../../app/modules/auth";

const SidebarMenuMain = () => {
  const { currentUser } = useAuth();

  // Determine user role and redirect accordingly
  const getUserRole = () => {
    if (!currentUser?.auth?.role) return null;
    return currentUser.auth.role;
  };

  const role = getUserRole();
  const intl = useIntl();

  // Check if user is INTERNAL or MERCHANT
  const isInternal = role?.startsWith("INTERNAL");
  const isMerchant = role?.startsWith("MERCHANT");

  // Role-based menu access for INTERNAL users
  const canAccessMerchantManagement = role === "INTERNAL_ADMIN";
  const canAccessUserManagement = role === "INTERNAL_ADMIN";
  const canAccessCheckUserFunds = role === "INTERNAL_ADMIN";
  const canAccessUserFunds =
    role === "INTERNAL_MAKER" ||
    role === "INTERNAL_APPROVAL" ||
    role === "MERCHANT_MAKER";
  const canAccessRefunds =
    role === "INTERNAL_MAKER" || role === "INTERNAL_APPROVAL";
  const canAccessTransactionHistory =
    role === "INTERNAL_ADMIN" ||
    role === "INTERNAL_MAKER" ||
    role === "INTERNAL_APPROVAL";

  // Role-based menu access for MERCHANT users
  const canAccessMerchantUserManagement = role === "MERCHANT_ADMIN";
  const canAccessMerchantTransfers =
    role === "MERCHANT_MAKER" || role === "MERCHANT_APPROVAL";
  const canAccessMerchantUserFunds =
    role === "MERCHANT_MAKER" || role === "MERCHANT_APPROVAL";
  const canAccessMerchantRefunds =
    role === "MERCHANT_MAKER" || role === "MERCHANT_APPROVAL";
  const canAccessMerchantTransactionHistory =
    role === "MERCHANT_ADMIN" ||
    role === "MERCHANT_MAKER" ||
    role === "MERCHANT_APPROVAL";

  return (
    <>
      {/* Internal User Menu */}
      {isInternal && (
        <>
          <SidebarMenuItemWithSub to="/settings/customers" title="Transactions">
            {canAccessUserFunds && (
              <SidebarMenuItem
                to="/internal/user-funds"
                icon="/media/icons/duotune/finance/fin008.svg"
                title={intl.formatMessage({ id: "MENU.USER-FUND" })}
                fontIcon="bi-app-indicator"
              />
            )}
            {canAccessRefunds && (
              <SidebarMenuItem
                to="/internal/refunds"
                icon="/media/icons/duotune/general/gen013.svg"
                title={intl.formatMessage({ id: "MENU.REFUND" })}
                fontIcon="bi-app-indicator"
              />
            )}
            {canAccessCheckUserFunds && (
              <SidebarMenuItem
                to="/internal/check-user-funds"
                icon="/media/icons/duotune/general/gen013.svg"
                title={intl.formatMessage({ id: "MENU.CHECK.USER.FUND" })}
                fontIcon="bi-app-indicator"
              />
            )}
            {canAccessMerchantManagement && (
              <SidebarMenuItem
                to="/internal/merchant-management"
                icon="/media/icons/duotune/ecommerce/ecm004.svg"
                title={intl.formatMessage({ id: "MENU.MERCHANT-MANAGEMENT" })}
                fontIcon="bi-app-indicator"
              />
            )}
            {canAccessUserManagement && (
              <SidebarMenuItem
                to="/internal/user-management"
                icon="/media/icons/duotune/communication/com014.svg"
                title={intl.formatMessage({ id: "MENU.USER-MANAGEMENT" })}
                fontIcon="bi-app-indicator"
              />
            )}
          </SidebarMenuItemWithSub>

          {canAccessTransactionHistory && (
            <SidebarMenuItemWithSub to="/settings/customers" title="Reports">
              <SidebarMenuItem
                to="/internal/transaction-history"
                icon="/media/icons/duotune/general/gen005.svg"
                title={intl.formatMessage({ id: "MENU.REPORT-TRANSFER" })}
                fontIcon="bi-app-indicator"
              />
            </SidebarMenuItemWithSub>
          )}
        </>
      )}

      {/* Merchant User Menu */}
      {isMerchant && (
        <>
          <SidebarMenuItemWithSub to="/settings/customers" title="Transactions">
            <SidebarMenuItem
              to="/merchant/homepage"
              icon="/media/icons/duotune/general/gen001.svg"
              title={intl.formatMessage({ id: "MENU.HOMEPAGE" })}
              fontIcon="bi-app-indicator"
            />
            {canAccessMerchantUserFunds && (
              <SidebarMenuItem
                to="/merchant/user-funds"
                icon="/media/icons/duotune/finance/fin008.svg"
                title={intl.formatMessage({ id: "MENU.USER-FUND" })}
                fontIcon="bi-app-indicator"
              />
            )}
            {canAccessMerchantTransfers && (
              <SidebarMenuItem
                to="/merchant/transfers"
                icon="/media/icons/duotune/general/gen016.svg"
                title={intl.formatMessage({ id: "MENU.TRANSFER" })}
                fontIcon="bi-app-indicator"
              />
            )}
            {/* {canAccessMerchantRefunds && (
              <SidebarMenuItem
                to="/merchant/refunds"
                icon="/media/icons/duotune/general/gen013.svg"
                title={intl.formatMessage({ id: "MENU.REFUND" })}
                fontIcon="bi-app-indicator"
              />
            )} */}
            <SidebarMenuItem
              to="/merchant/check-user-funds"
              icon="/media/icons/duotune/general/gen013.svg"
              title={intl.formatMessage({ id: "MENU.CHECK.USER.FUND" })}
              fontIcon="bi-app-indicator"
            />
            {canAccessMerchantUserManagement && (
              <SidebarMenuItem
                to="/merchant/user-management"
                icon="/media/icons/duotune/communication/com014.svg"
                title={intl.formatMessage({ id: "MENU.USER-MANAGEMENT" })}
                fontIcon="bi-app-indicator"
              />
            )}
          </SidebarMenuItemWithSub>

          {canAccessMerchantTransactionHistory && (
            <SidebarMenuItemWithSub to="/settings/customers" title="Reports">
              <SidebarMenuItem
                to="/merchant/transaction-history"
                icon="/media/icons/duotune/general/gen005.svg"
                title={intl.formatMessage({ id: "MENU.REPORT-TRANSFER" })}
                fontIcon="bi-app-indicator"
              />
            </SidebarMenuItemWithSub>
          )}
        </>
      )}

      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Reports</span>
        </div>
      </div> */}
    </>
  );
};

export { SidebarMenuMain };
